(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/logout/assets/javascript/init.js') >= 0) return;  svs.modules.push('/modules/logout/assets/javascript/init.js');

'use strict';

svs.logout.init = async () => {
  var _svs$logout$data$uris;
  const iframe = document.getElementById('iam-logout-iframe');
  new svs.ui.Loader('.js-logout-view-loader').show(300);
  iframe.src = (_svs$logout$data$uris = svs.logout.data.uris) === null || _svs$logout$data$uris === void 0 ? void 0 : _svs$logout$data$uris.asEndSession;
  iframe.onload = function () {
    var _svs$logout$data$uris2;
    window.location = (_svs$logout$data$uris2 = svs.logout.data.uris) === null || _svs$logout$data$uris2 === void 0 ? void 0 : _svs$logout$data$uris2.oauth2SignOut;
  };

  setTimeout(() => {
    var _svs$logout$data$uris3;
    window.location = (_svs$logout$data$uris3 = svs.logout.data.uris) === null || _svs$logout$data$uris3 === void 0 ? void 0 : _svs$logout$data$uris3.oauth2SignOut;
  }, 2000);
};
svs.logout.init();

 })(window);